// The code in this file will load on every page of your site


import wixWindow from 'wix-window';

$w.onReady(function () {
	if (wixWindow.multilingual.currentLanguage === 'en') {
		$w('#menuen').show();
		$w('#menuhe').hide();
	} else {
		$w('#menuhe').show();
		$w('#menuen').hide();
	}
});